import useHttp from 'use-http';

export default () => {
  const [request, response, isLoading, error] = useHttp(global.location.origin, {}, []);

  return {
    request,
    get: request.get,
    post: request.post,
    response,
    isLoading,
    error,
    useHttp
  };
};
